export enum PraClaimMethod {
  PreviousCME = 'previous_cme',
  ABMS = 'abms',
  Reciprocity = 'reciprocity',
  Residency = 'residency',
}
